import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureAttribution } from "../lib/attribution";

/**
 * Invisible component. Captures the customer's first-touch acquisition
 * signals (UTM params, gclid, fbclid, referrer, landing path) into
 * sessionStorage on the very first route render. Subsequent route
 * changes are no-ops — first touch wins.
 */
export default function AttributionCapture() {
  // Re-run on location change in case the user clicks an ad in a new tab
  // and lands on a deep link. The capture itself is idempotent (first
  // call per session wins), so this is safe.
  const location = useLocation();
  useEffect(() => {
    captureAttribution();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.search]);
  return null;
}
